import { RewardPoolLeaderboardEntry } from '@shared/api/types/rewardPools';

export const getWinningEntries = (
  entries: RewardPoolLeaderboardEntry[] = [],
): RewardPoolLeaderboardEntry[] => {
  return entries?.filter((entry) => entry.reward);
};
